import en from './en';
import { panelDepositWithdrawInboxByLang } from './partials/panelDepositWithdrawInbox';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelInvestmentsByLang } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignByLang } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralCurrentRankMinDepositByLang } from './partials/panelReferralRankingI18n';

function merge(partial) {
  return { ...en, ...partial };
}

/** Spanish */
export default merge({
  'common.theme': 'Tema',
  'common.themeLight': 'Claro',
  'common.themeDark': 'Oscuro',
  'common.themeActive': 'Activo actualmente',
  'common.themeSwitchToDark': 'Cambiar a oscuro',
  'common.themeSwitchToLight': 'Cambiar a claro',
  'common.ariaSwitchToLightTheme': 'Cambiar a tema claro',
  'common.ariaSwitchToDarkTheme': 'Cambiar a tema oscuro',
  'common.ariaToggleMobileSidebar': 'Alternar menú lateral',
  'common.ariaCloseSidebarBackdrop': 'Cerrar fondo del menú',
  'common.ariaAccountMenu': 'Menú de cuenta',
  'common.settings': 'Ajustes',
  'common.loading': 'Cargando…',
  'settings.language': 'Idioma',
  'settings.languagePlaceholder': 'Seleccionar idioma',
  'settings.savePreferences': 'Guardar preferencias',
  'settings.savingPreferences': 'Guardando…',
  'auth.gate.userTitle': 'Verificando tu sesión',
  'auth.gate.userDescription': 'Confirmando tu acceso. Solo un momento.',
  'auth.gate.agentTitle': 'Verificando tu sesión',
  'auth.gate.agentDescription': 'Confirmando tu acceso de agente. Solo un momento.',
  'auth.page.themeLight': 'Claro',
  'auth.page.themeDark': 'Oscuro',
  'auth.page.ariaTheme': 'Cambiar tema',
  'user.layout.sidebarTitle': 'Panel de usuario MineMe',
  'user.layout.investorAccount': 'Cuenta de inversor',
  'user.layout.nav.dashboard': 'Panel',
  'user.layout.nav.deposit': 'Depósito',
  'user.layout.nav.withdraw': 'Retiro',
  'user.layout.nav.investments': 'Inversiones',
  'user.layout.nav.referral': 'Referidos',
  'user.layout.nav.notifications': 'Notificaciones',
  'user.layout.nav.stopLoss': 'Stop-Loss',
  'user.layout.nav.transactions': 'Transacciones',
  'user.layout.nav.settings': 'Ajustes',
  'user.layout.logout': 'Cerrar sesión',
  'user.layout.balance.available': 'Saldo disponible',
  'user.layout.balance.frozen': 'Saldo congelado',
  'user.layout.balance.interest': 'Saldo de intereses',
  'user.layout.balance.bonus': 'Saldo de bono',
  'user.layout.market.loading': 'Cargando datos de mercado…',
  'user.layout.market.unavailable': 'Mercado no disponible',
  'user.layout.mobilePanel': 'Panel',
  'user.layout.portfolioWorkspace': 'Espacio de cartera',
  'agent.layout.sidebarTitle': 'MineMe Agente',
  'agent.layout.role': 'Cuenta de agente',
  'agent.layout.nav.dashboard': 'Panel',
  'agent.layout.nav.referrals': 'Referidos',
  'agent.layout.nav.commissions': 'Comisiones',
  'agent.layout.nav.team': 'Mi equipo',
  'agent.layout.nav.transactions': 'Transacciones',
  'agent.layout.nav.withdraw': 'Retiro',
  'agent.layout.nav.notifications': 'Notificaciones',
  'agent.layout.nav.settings': 'Ajustes',
  'agent.layout.withdrawalLogs': 'Historial de retiros',
  'agent.layout.stats.commission': 'Saldo de comisiones',
  'agent.layout.stats.direct': 'Referidos directos',
  'agent.layout.stats.earned': 'Total ganado',
  'agent.layout.workspace': 'Espacio de agente',
  'agent.layout.logout': 'Cerrar sesión',
  'auth.user.login.title': 'Acceso de usuario',
  'auth.user.login.subtitle': 'Inicia sesión en tu panel de usuario.',
  'auth.user.login.noAccount': '¿No tienes cuenta?',
  'auth.user.login.createAccount': 'Crear cuenta',
  'auth.user.login.username': 'Usuario',
  'auth.user.login.password': 'Contraseña',
  'auth.user.login.placeholderUsername': 'Introduce tu usuario',
  'auth.user.login.placeholderPassword': 'Introduce tu contraseña',
  'auth.user.login.forgotPassword': '¿Olvidaste la contraseña?',
  'auth.user.login.signIn': 'Entrar',
  'auth.user.login.signingIn': 'Entrando…',
  'auth.agent.login.title': 'Acceso de agente',
  'auth.agent.login.subtitle': 'Inicia sesión con tu usuario y contraseña de agente.',
  'auth.agent.login.needAccount': '¿Necesitas cuenta?',
  'auth.agent.login.signUp': 'Registrarse',
  'auth.agent.login.usernameHint':
    'Letras y números; los guiones se ignoran (p. ej. AGT-00142 funciona).',
  'auth.agent.login.placeholderUsername': 'Tu usuario de agente',
  'auth.agent.login.placeholderPassword': 'Tu contraseña',
  'auth.agent.login.forgotPassword': '¿Olvidaste la contraseña?',
  'auth.agent.login.signIn': 'Entrar',
  'auth.agent.login.signingIn': 'Entrando…',
  'auth.agent.login.ariaShowPassword': 'Mostrar contraseña',
  'auth.agent.login.ariaHidePassword': 'Ocultar contraseña',
  'auth.user.forgot.title': 'Recuperar contraseña',
  'auth.user.forgot.subtitle': 'Restablece con tu frase de recuperación de 12 palabras.',
  'auth.user.forgot.remember': '¿Recuerdas tu contraseña?',
  'auth.user.forgot.signIn': 'Entrar',
  'auth.user.forgot.intro':
    'Usa el mismo usuario y email de tu cuenta, más la frase guardada al registrarte. Cuentas anteriores a frases de recuperación no pueden usar este flujo.',
  'auth.user.forgot.username': 'Usuario',
  'auth.user.forgot.email': 'Correo',
  'auth.user.forgot.recoveryPhrase': 'Frase de recuperación',
  'auth.user.forgot.newPassword': 'Nueva contraseña',
  'auth.user.forgot.confirmPassword': 'Confirmar nueva contraseña',
  'auth.user.forgot.submit': 'Restablecer contraseña',
  'auth.user.forgot.submitting': 'Restableciendo…',
  'auth.user.forgot.placeholderUsername': 'Tu usuario',
  'auth.user.forgot.placeholderEmail': 'Email de la cuenta',
  'auth.user.forgot.placeholderRecovery': 'Introduce tu frase de 12 palabras',
  'auth.user.forgot.placeholderNew': 'Al menos 8 caracteres',
  'auth.user.forgot.placeholderConfirm': 'Repite la nueva contraseña',

  'common.time.days': 'Días',
  'common.time.hours': 'Horas',
  'common.time.minutes': 'Minutos',
  'common.time.seconds': 'Segundos',
  'common.cancel': 'Cancelar',
  'common.dismissNotification': 'Cerrar notificación',

  'user.dashboard.title': 'Panel',
  'user.dashboard.loadingInvestments': 'Cargando estado de inversión…',

  'user.dashboard.balance.available': 'Saldo disponible',
  'user.dashboard.balance.frozen': 'Saldo congelado',
  'user.dashboard.balance.interest': 'Intereses ganados',
  'user.dashboard.balance.bonus': 'Saldo de bono',

  'user.dashboard.stats.totalInvested': 'Total invertido',
  'user.dashboard.stats.netPnl': 'Beneficio / pérdida neta',
  'user.dashboard.stats.activePlans': 'Planes activos',

  'user.dashboard.noInvestment.title': 'Sin inversión activa',
  'user.dashboard.noInvestment.subtitle':
    'Empieza a invertir hoy y haz crecer tu patrimonio con rendimientos atractivos',
  'user.dashboard.noInvestment.cta': 'Ver planes de inversión',

  'user.dashboard.recentTx.title': 'Transacciones recientes',
  'user.dashboard.recentTx.viewAll': 'Ver todas',
  'user.dashboard.recentTx.col.date': 'Fecha',
  'user.dashboard.recentTx.col.type': 'Tipo',
  'user.dashboard.recentTx.col.description': 'Descripción',
  'user.dashboard.recentTx.col.amount': 'Importe',
  'user.dashboard.recentTx.col.status': 'Estado',
  'user.dashboard.recentTx.loading': 'Cargando transacciones recientes…',
  'user.dashboard.recentTx.empty': 'No hay transacciones recientes.',

  'user.dashboard.tx.Deposit': 'Depósito',
  'user.dashboard.tx.Investment': 'Inversión',
  'user.dashboard.tx.Referral': 'Referido',
  'user.dashboard.tx.Bonus': 'Bono',
  'user.dashboard.tx.Withdrawal': 'Retiro',
  'user.dashboard.tx.E-Voucher': 'E-Voucher',
  'user.dashboard.tx.Stop-Loss': 'Stop-Loss',

  'user.dashboard.st.Completed': 'Completado',
  'user.dashboard.st.Active': 'Activo',
  'user.dashboard.st.Pending': 'Pendiente',
  'user.dashboard.st.Failed': 'Fallido',

  'user.dashboard.invest.planFallback': 'Plan',
  'user.dashboard.invest.activeBadge': 'Activo',
  'user.dashboard.invest.detail.amountInvested': 'Importe invertido',
  'user.dashboard.invest.detail.currentValue': 'Valor actual',
  'user.dashboard.invest.detail.pl': 'B/P',
  'user.dashboard.invest.detail.interestRate': 'Tipo de interés',
  'user.dashboard.invest.detail.perMonth': '{{pct}}% / mes',
  'user.dashboard.invest.detail.duration': 'Duración',
  'user.dashboard.invest.detail.months': '{{n}} meses',
  'user.dashboard.invest.detail.startDate': 'Fecha de inicio',
  'user.dashboard.invest.detail.nextWithdrawal': 'Próximo retiro',
  'user.dashboard.invest.countdownTitle': 'Próximo retiro en',
  'user.dashboard.invest.progress': 'Progreso',
  'user.dashboard.invest.progressPct': '{{pct}}% completado',
  'user.dashboard.invest.earlyWithdraw': 'Retiro anticipado',
  'user.dashboard.invest.planChip': '{{name}} n.º {{num}}',

  'user.dashboard.invest.modal.title': 'Aviso de retiro anticipado',
  'user.dashboard.invest.modal.investmentAmount': 'Importe invertido:',
  'user.dashboard.invest.modal.platformFee': 'Comisión de plataforma ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'Intereses perdidos:',
  'user.dashboard.invest.modal.youWillReceive': 'Recibirás:',
  'user.dashboard.invest.modal.confirmHint': 'Escribe "CONFIRM" para continuar',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Confirmar retiro',
  'user.dashboard.invest.modal.cancelling': 'Cancelando…',
  'user.dashboard.invest.toast.cancelled': 'Inversión cancelada',
  'user.dashboard.invest.toast.cancelFailed': 'No se pudo cancelar',

  'notifications.bell.triggerAria': 'Notificaciones',
  'notifications.bell.title': 'Notificaciones',
  'notifications.bell.loading': 'Cargando…',
  'notifications.bell.loadErrorSubtitle': 'No se pudieron cargar las notificaciones',
  'notifications.bell.unreadOne': '1 actualización sin leer',
  'notifications.bell.unreadMany': '{{count}} actualizaciones sin leer',
  'notifications.bell.allCaughtUp': 'Todo al día',
  'notifications.bell.markAllRead': 'Marcar todo como leído',
  'notifications.bell.empty': 'Aún no hay notificaciones',
  'notifications.bell.emptyError': 'No se pudieron cargar las notificaciones',
  'notifications.bell.viewAll': 'Ver todo',
  'notifications.bell.markReadAria': 'Marcar como leído',
  'notifications.bell.time.justNow': 'ahora',
  'notifications.bell.time.secondsAgo': 'hace {{n}} s',
  'notifications.bell.time.minutesAgo': 'hace {{n}} min',
  'notifications.bell.time.hoursAgo': 'hace {{n}} h',
  'notifications.bell.time.daysAgo': 'hace {{n}} d',

  'user.socialProof.network': 'USDT (TRC20)',
  'user.socialProof.label': 'Retiro',
  'user.socialProof.withdrew': 'Retiró con éxito {{amount}} vía {{network}}',
  'user.socialProof.time.justNow': 'ahora mismo',
  'user.socialProof.time.sec30': 'hace 30 s',
  'user.socialProof.time.min1': 'hace 1 min',
  'user.socialProof.time.min2': 'hace 2 min',
  'user.socialProof.time.min3': 'hace 3 min',

  'common.confirm': 'Confirmar',
  'common.submitting': 'Enviando…',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.max': 'MÁX',
  'common.copyValue': 'Copiar valor',
  'common.copied': '¡Copiado!',

  ...panelDepositWithdrawInboxByLang.es,
  ...panelDepositBonusByLang.es,
  ...panelVoucherStatusByLang.es,

  ...panelSettingsTransactionsByLang.es,
  ...panelReferralCurrentRankMinDepositByLang.es,
  ...panelUserExtraByLang.es,
  ...panelInvestmentsByLang.es,
  'user.investments.card.dailyProfit': 'Beneficio diario',
  'user.investments.card.earningDays': 'Días hábiles',
  'user.investments.card.earningDaysValue': '{{count}} días hábiles',
  'user.investments.card.expectedProfit': 'Beneficio esperado',
  'user.investments.card.investLimit': 'Límite de inversión',
  'user.investments.card.investLimitLine': '{{count}}× en {{days}} días',
  'user.investments.card.investLimitReached':
    'Has alcanzado el límite de inversión de este plan en el período actual.',
  'user.investments.card.limitReached': 'Límite alcanzado',
  ...panelStopLossSlotsAssignByLang.es,
  ...panelStopLossFlowByLang.es,
  ...panelUserSignupSocialForgotByLang.es,
  ...panelAgentDashboardByLang.es,
  ...panelAgentReferralsByLang.es,
  ...panelAgentCommissionsByLang.es,
  ...panelAgentWithdrawByLang.es,
  ...panelAgentWithdrawUnlockStringsByLang.es,
  'agent.withdraw.unlock.loadingTitle': 'Comprobando estado de retiros…',
  'agent.withdraw.unlock.loadingSubtitle':
    'Cargando tu progreso de referidos y requisitos de desbloqueo',
  'agent.withdraw.form.loadingTitle': 'Cargando datos de retiro…',
  'agent.withdraw.form.loadingHint': 'Espera mientras cargamos tu saldo y estado de desbloqueo',
  'agent.withdraw.unlock.requirementMet': 'Requisito cumplido',
  'agent.withdraw.unlock.minDepositHint':
    'Solo cuentan usuarios referidos (no sub-agentes). Cada uno debe tener al menos ${{amount}} en depósitos completados.',
  ...panelAgentTransactionsByLang.es,
  ...panelAgentLogsByLang.es,
  ...panelAgentSettingsByLang.es,
  ...panelAgentNotificationsByLang.es,
  ...panelAgentTeamByLang.es,
  ...panelAgentSignupByLang.es,
  ...panelAgentLayoutByLang.es,
  ...panelAgentAuthByLang.es,
  ...panelUserPlatformTodayByLang.es,
  ...panelStopLossHowLayoutByLang.es,
  ...panelSupportTicketsByLang.es,
});
